export default {
    title: "Enquête soumise",
    header: "@:views.survey.submitted.title",
    message: "Merci pour votre avis.",
}